import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
    name: "FacilityUserAddRoleDialog",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            dialog: false,
            roleName: '',
            loading: false,
            roles: [],
        }
    },
    computed: {
        usersRoles() {
            return this.$store.state.userModule.usersRoles;
        },
        facility() {
            return this.$store.state.authModule.currentFacilityData;
        }
    },
    methods: {
        open() {
            this.dialog = true;
        },
        cancel() {
            this.$refs.observer.reset();
            this.roleName = "";
            this.loading = false;
            this.dialog = false;
        },
        async addRole() {
            this.loading = true;

            if(this.roles.find(x => x.name.trim() === this.roleName.trim())) {
                this.$refs.observer.setErrors({
                    role: ["The job title already exists for this organization."]
                });
                this.loading = false;
                return false;
            }

            const role = {
                name: this.roleName,
                orgId: this.facility.orgId,
                dateTimeCreated: new Date(),
            }
            await this.$store.dispatch("addUserRole", role).then(() => {
                this.cancel();
            }).catch((error) => {
                this.$toast.open({
                    message: error,
                    type: "error"
                });
            })
        },
    },
    created() {
        this.$store.dispatch("getUsersRoles");
    },
    watch:{
        usersRoles(){
            this.roles = this.usersRoles
        }
    },
}